@if (authenticationError(); as error) {
  <div class="loader-container" role="alert">
    <p>{{ error }}</p>
    <button mat-flat-button type="button" (click)="retryLogin()">Sign in again</button>
  </div>
} @else if (!isAuthenticated()) {
  <div class="loader-container">
    <mat-spinner></mat-spinner>
    <p>Loading...</p>
  </div>
} @else {
  <div class="app-container">
    <!-- Modern Navigation Bar with Icons -->
    <app-navbar [currentUser]="currentUser()" [siteTitle]="siteTitle()"></app-navbar>

    <main class="content">
      <!-- Router outlet will go here for different pages -->
      <router-outlet></router-outlet>
    </main>

    <!-- Footer appears globally on all pages -->
    <app-footer></app-footer>
  </div>
}